export { FileAttachments, operations, defaultChangeHandler } from './fileAttachments'



// WEBPACK FOOTER //
// ./src/components/fileAttachments/index.js